const ITF_AFTER_TECH_PAIRS = [
  ['tech-service-all', 'itf-all'],
  ['tech-service-view', 'itf-view'],
  ['company-tech-service', 'itf-company'],
]

function pageKey(page) {
  return page.route || page.slug || ''
}

/**
 * Ensure ITF list page sits immediately after Տեխզննում for all roles.
 * Operator sidebar is hardcoded separately and should not use this.
 */
export function placeItfAfterTechService(pages) {
  if (!Array.isArray(pages) || !pages.length) return pages

  const result = [...pages]

  ITF_AFTER_TECH_PAIRS.forEach(([techRoute, itfRoute]) => {
    const itfIndex = result.findIndex(p => pageKey(p) === itfRoute)
    const techIndex = result.findIndex(p => pageKey(p) === techRoute)
    if (itfIndex === -1 || techIndex === -1) return

    const [itfItem] = result.splice(itfIndex, 1)
    const newTechIndex = result.findIndex(p => pageKey(p) === techRoute)
    if (newTechIndex === -1) {
      result.splice(itfIndex, 0, itfItem)
      return
    }
    result.splice(newTechIndex + 1, 0, itfItem)
  })

  return result
}
